(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('layoutTemplateComponentOption', {
            templateUrl: 'app/admin/showcase-layout-template/components/layout-template-component-option/layout-template-component-option.html',
            bindings: {
                option: '=',
                onInsert: '&'
            }
        });
})();
